import "styles/globals.css";
import "styles/hamburger.css";
import * as React from "react";
import type { AppProps } from "next/app";
import Head from "next/head";
import { globalCss } from "utils";

const globalStyles = globalCss({
  body: { fontFamily: "$body", fontWeight: "normal", color: "$secondary" },
});

function App({ Component, pageProps }: AppProps) {
  globalStyles();
  return (
    <>
      <Head>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>Campos Uy</title>
        <meta
          name="description"
          content="Bridamos asesoramiento personalizado con nuestro equipo de experto en la compra, venta, arrendamiento de campos."
        />
        <meta property="og:site_name" content="Campos Uy" />
        <meta property="og:site" content="https://camposuy.com/" />
        <meta property="og:title" content="Campos Uy" />
        <meta
          property="og:description"
          content="Bridamos asesoramiento personalizado con nuestro equipo de experto en la compra, venta, arrendamiento de campos."
        />
        <meta property="og:url" content="https://camposuy.com/" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://campos-test.vercel.app/apple-touch-icon.png"
        />
        <meta property="og:image:width" content="1280" />
        <meta property="og:image:height" content="640" />
        <meta property="twitter:card" content="summary" />
      </Head>
      <Component {...pageProps} />
    </>
  );
}

export default App;
